import { User } from '../models/user.model';
import { Administradora } from '../models/administradora-parametro.model';
import { IdentificarRequest } from '../models/auth.model';

/**
 * Etapa atual do fluxo de login. CONFIRMADO na tela real (tenant
 * conectaplan, 24/08/2026): o passo 2 (senha) aparece na MESMA URL
 * `/{tenant}/` do passo 1 — sem navegação de rota — então modelamos isso
 * como um estado dentro do slice `core`, não como rotas separadas.
 */
export type LoginEtapa = 'identificacao' | 'senha';

export interface ICoreState {
  // Slug do tenant, extraído do primeiro segmento da URL (rota `:tenant`,
  // ver TenantResolver) — ex.: "affixbeneficios".
  tenantSlug: string | null;

  // Configuração do tenant (Administradora), carregada no boot a partir do
  // slug acima. `null` = ainda não carregado OU carregado mas o tenant não
  // tem cadastro (caso real observado: affixbeneficios em homologação
  // responde 204 em ParametrosCompletos). CONFIRMADO via resposta real
  // (tenant conectaplan, 24/08/2026) que o payload é o objeto `Administradora`
  // inteiro (CNPJ, endereço, cores, `parametros[]` etc.), não só a lista de
  // parâmetros — ver core/models/administradora-parametro.model.ts.
  administradora: Administradora | null;
  administradoraLoaded: boolean;
  administradoraError: string | null;

  // Autenticação — passo 1 (identificação por CPF/CNPJ + data de
  // nascimento, endpoint confirmado `PossuiSenhaExterna`) e passo 2 (senha,
  // endpoint confirmado `LoginExterno`), ambos na mesma URL `/{tenant}/`.
  // `identificacaoRequest` guarda o `sCPF` do passo 1 (precisamos dele pro
  // passo 2, ver `LoginRequest.sLoginExterno` em auth.model.ts).
  // `iCodSegurado` vem da RESPOSTA do passo 1 e é EXIGIDO pelo passo 2 —
  // CONFIRMADO em 25/08/2026 (produção) inspecionando as chaves do request
  // real de `LoginExterno`.
  // Token de SESSÃO de curta duração (~2h), devolvido por
  // `Token/AtualizarTokenSessao` (chamado no fim do passo 1) — EXIGIDO como
  // `Authorization` do passo 2 (`LoginExterno`), no lugar do `partnerToken`
  // estático. CONFIRMADO em 26/08/2026 (homologação): mandar o
  // `partnerToken` no passo 2 resulta em HTTP 401 "Usuário sem permissão de
  // acesso" — ver core/store/effects.ts.
  loginEtapa: LoginEtapa;
  identificacaoRequest: IdentificarRequest | null;
  iCodSegurado: number | null;
  tokenSessaoLogin: string | null;
  identificarError: string | null;
  loginError: string | null;

  // `user`/`token` representam a sessão final (pós passo 2). Contrato real
  // de `LoginExterno` não confirmado — ver core/store/effects.ts.
  user: User | null;
  token: string | null;

  sidenavOpened: boolean;
  appVersion: string;
}

export const initialCoreState: ICoreState = {
  tenantSlug: null,
  administradora: null,
  administradoraLoaded: false,
  administradoraError: null,
  loginEtapa: 'identificacao',
  identificacaoRequest: null,
  iCodSegurado: null,
  tokenSessaoLogin: null,
  identificarError: null,
  loginError: null,
  user: null,
  token: null,
  sidenavOpened: true,
  appVersion: '0.0.0',
};

export interface IAppState {
  core: ICoreState;
}
